import {useState} from 'react';
import {initial} from '../../common/domain/RemoteData.model';
import {signup as _signup} from '../infrastructure/UserApi';
import {remoteDataWithSetter} from '../../common/utils/remoteDataWithSetter';

/** Alta nueva: el exito devuelve {id, email} y la pantalla pasa al codigo de verificacion. */
export const useSignup = () => {
  const [signupRemoteData, setSignupRemoteData] = useState(initial(null));

  const signup = async (userInfo, tenantId) => {
    const dataSetterCallback = () => _signup(userInfo, tenantId);
    await remoteDataWithSetter(setSignupRemoteData, dataSetterCallback);
  }

  return { signupRemoteData, signup };
}